import { baseApi } from "./baseApi";
import * as API from "@utils/apiPath";
import type { ApiResponse, EmailPayload } from "interface/email";

export const emailApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getEmails: builder.query<ApiResponse, { [key: string]: string | number }>({
      query: (params) => ({
        url: API.GET_EMAIL,
        method: "GET",
        params,
      }),
      providesTags: ["Email"],
    }),
    updateEmail: builder.mutation<ApiResponse, EmailPayload>({
      query: ({ params }) => ({
        url: API.GET_EMAIL,
        method: "PUT",
        body: params,
      }),
      invalidatesTags: ["Email"],
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
          arg.onClose();
        } catch (error) {
          console.error("Failed to update email:", error);
        }
      },
    }),
  }),
});

export const { useGetEmailsQuery, useUpdateEmailMutation } = emailApi;

